import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import enTranslations from "./translations/en/en.json"
import itTranslations from "./translations/it/it.json"
import plTranslations from "./translations/pl/pl.json"

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    it: {
      translation: itTranslations,
    },
    pl: {
      translation: plTranslations,
    },
  },
  lng: process.env.REACT_APP_DEFAULT_LANGUAGE || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
